module.exports = __webpack_public_path__ + "img/illustrations/encourage-sharing-envelope-ddb105e731fe0d86f83bf079c0d1e837.svg";